var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNursePointerRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_323_1306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 14.7452 18.7452 4 32 4C45.2548 4 56 14.7452 56 28V52H32C18.7452 52 8 41.2548 8 28Z",
    fill: "white",
    stroke: "#003893",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 27.9999,
    r: 22.9091,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_1306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8089 16.5667C28.0308 16.5667 23.223 20.6955 22.0177 26.1872H33.8089V16.5667Z",
    fill: "#00235C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.863 23.9063C42.9906 19.5931 38.7587 16.5667 33.8089 16.5667V26.1872H44.4369C45.0247 25.5882 45.1994 24.6811 44.863 23.9063Z",
    fill: "#003893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8588 35.4262C25.9868 35.4262 28.5226 32.8414 28.5226 29.6529C28.5226 26.4644 25.9868 23.8796 22.8588 23.8796C19.7307 23.8796 17.195 26.4644 17.195 29.6529C17.195 32.8414 19.7307 35.4262 22.8588 35.4262Z",
    fill: "#00235C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9793 12.3919C40.2229 10.9781 37.1082 10.1818 33.8089 10.1818L31.3464 11.1699V20.689H41.153L44.0016 16.6925C45.0339 15.2442 44.5481 13.1964 42.9793 12.3919Z",
    fill: "#6CF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6406 10.3626C33.6949 10.3013 33.751 10.241 33.809 10.1818C30.5098 10.1818 27.3951 10.978 24.6386 12.3919C23.0698 13.1964 22.5841 15.2443 23.6163 16.6925L26.4649 20.689H33.8089V17.7214C31.8934 15.6941 31.7953 12.4293 33.6406 10.3626Z",
    fill: "#00CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.373 41.1457C37.531 40.068 36.3363 39.2934 34.9707 39.0093H33.226L29.7431 42.5596V45.2691L30.2818 45.8182H33.3132L33.8089 45.4333L34.3046 45.8182H37.336L39.5125 43.5562C39.3116 42.6602 38.9155 41.84 38.373 41.1457Z",
    fill: "#00CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3132 38.8903H34.3047V45.8182H33.3132V38.8903Z",
    fill: "#003893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9707 39.0094C34.595 38.9312 34.2065 38.8903 33.8088 38.8903C31.9652 38.8903 30.3184 39.7716 29.2448 41.1457C28.7023 41.84 28.3062 42.6602 28.1052 43.5562V44.2573H30.3165C30.5923 41.6457 32.5026 39.5234 34.9707 39.0094Z",
    fill: "#00CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7918 44.5705C36.0656 44.5705 36.2875 44.3443 36.2875 44.0652C36.2875 43.7862 36.0656 43.5599 35.7918 43.5599C35.518 43.5599 35.2961 43.7862 35.2961 44.0652C35.2961 44.3443 35.518 44.5705 35.7918 44.5705Z",
    fill: "#00CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6615 44.9083V45.8182H37.336V44.9083C37.336 44.6887 37.3244 44.4718 37.3019 44.2581C38.0618 44.0795 38.7999 43.8442 39.5125 43.5562C39.61 43.9911 39.6615 44.4435 39.6615 44.9083Z",
    fill: "#FFE9DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1053 43.5562C28.0077 43.9911 27.9562 44.4435 27.9562 44.9083V45.8182H30.2818V44.9083C30.2818 44.6887 30.2941 44.471 30.3166 44.2573C29.5567 44.0787 28.8179 43.8442 28.1053 43.5562Z",
    fill: "#FFE9DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.71 39.9979L36.6691 39.6593L33.8089 37.8888L30.9488 39.6593L30.9078 39.998C30.6991 41.7266 32.7523 42.6743 33.8089 41.3371C34.8655 42.6743 36.9188 41.7265 36.71 39.9979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.759 26.1888H22.8588C21.399 26.1888 20.2156 27.3951 20.2156 28.8831C20.2156 30.3711 21.399 31.5773 22.8588 31.5773H44.759C46.2188 31.5773 47.4022 30.3711 47.4022 28.8831C47.4022 27.3951 46.2188 26.1888 44.759 26.1888Z",
    fill: "#FFCBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4369 26.1872L38.8025 20.6889H29.878L22.8588 28.883L32.2874 39.8899H35.6324C35.984 39.8298 36.3298 39.7526 36.6691 39.6593C41.3295 38.3772 44.759 34.0388 44.759 28.8831C44.759 27.9535 44.647 27.0506 44.4369 26.1872Z",
    fill: "#FFE9DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6324 17.8763H32.2874L26.4839 24.6511L27.0845 25.2633C27.6402 24.9448 28.1557 24.5484 28.6146 24.0807C29.9192 22.7508 31.6379 21.9742 33.8089 21.9742C35.9799 21.9742 37.6986 22.7509 39.0033 24.0807C40.3265 25.4295 42.1212 26.1872 43.9925 26.1872H44.437C43.3969 21.9138 39.9414 18.6127 35.6324 17.8763Z",
    fill: "#003893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4911 28.8986C26.4911 27.6259 26.7002 26.403 27.0845 25.2634H24.9387L23.181 26.1873C22.9711 27.0503 22.8589 27.9531 22.8589 28.8831C22.8589 34.0503 26.2987 38.3783 30.9489 39.6593C31.8616 39.9107 32.8198 40.0449 33.809 40.0449C34.4304 40.0449 35.0395 39.9913 35.6326 39.8899C30.4453 39.0073 26.4911 34.4393 26.4911 28.8986Z",
    fill: "#FFCBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6325 17.8763C35.0393 17.7749 34.4303 17.7213 33.8089 17.7213C28.684 17.7213 24.3655 21.3184 23.181 26.1872H23.6253C24.8478 26.1872 26.0375 25.8636 27.0845 25.2633C28.3732 21.4413 31.6368 18.5562 35.6325 17.8763Z",
    fill: "#00235C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.843 34.3198C29.0525 34.3198 30.033 33.5271 30.033 32.5493C30.033 31.5715 29.0525 30.7788 27.843 30.7788C26.6335 30.7788 25.653 31.5715 25.653 32.5493C25.653 33.5271 26.6335 34.3198 27.843 34.3198Z",
    fill: "#FF8E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7748 34.3198C40.9843 34.3198 41.9648 33.5271 41.9648 32.5493C41.9648 31.5715 40.9843 30.7788 39.7748 30.7788C38.5653 30.7788 37.5848 31.5715 37.5848 32.5493C37.5848 33.5271 38.5653 34.3198 39.7748 34.3198Z",
    fill: "#FF8E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0929 29.3846C28.8015 29.3846 28.5653 29.6253 28.5653 29.9224V30.8461C28.5653 31.1432 28.8015 31.3839 29.0929 31.3839C29.3843 31.3839 29.6205 31.1432 29.6205 30.8461V29.9224C29.6205 29.6253 29.3843 29.3846 29.0929 29.3846Z",
    fill: "#00235C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5249 29.3846C38.2335 29.3846 37.9973 29.6253 37.9973 29.9224V30.8461C37.9973 31.1432 38.2335 31.3839 38.5249 31.3839C38.8163 31.3839 39.0525 31.1432 39.0525 30.8461V29.9224C39.0525 29.6253 38.8163 29.3846 38.5249 29.3846Z",
    fill: "#00235C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3988 30.4131C35.1791 30.2179 34.8459 30.2413 34.6545 30.4653C34.441 30.7149 34.1328 30.8581 33.8089 30.8581C33.485 30.8581 33.1768 30.7149 32.9633 30.4652C32.7718 30.2413 32.4387 30.218 32.2189 30.4131C31.9992 30.6082 31.9764 30.9479 32.1678 31.1718C32.5817 31.656 33.1799 31.9337 33.8089 31.9337C34.4379 31.9337 35.036 31.656 35.45 31.1718C35.6414 30.9479 35.6185 30.6082 35.3988 30.4131Z",
    fill: "#00235C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3127 13.4139H34.2523V12.3329C34.2523 12.0359 34.0161 11.7952 33.7247 11.7952C33.4334 11.7952 33.1972 12.0359 33.1972 12.3329V13.4139H32.1367C31.8454 13.4139 31.6092 13.6546 31.6092 13.9516C31.6092 14.2487 31.8454 14.4894 32.1367 14.4894H33.1972V15.5703C33.1972 15.8673 33.4334 16.108 33.7247 16.108C34.0161 16.108 34.2523 15.8673 34.2523 15.5703V14.4894H35.3127C35.6041 14.4894 35.8403 14.2487 35.8403 13.9516C35.8403 13.6546 35.6041 13.4139 35.3127 13.4139Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_323_1306",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_323_1306"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_323_1306",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_1306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.9607,
    height: 35.6364,
    fill: "white",
    transform: "translate(14.8182 10.1818)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNursePointerRight);
export default __webpack_public_path__ + "static/media/Nurse_pointer_right.8d91a3f2658ec1fcae3253983a8dc2c5.svg";
export { ForwardRef as ReactComponent };